import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {
  ConcentrationLayerInput,
  MetadataColumnInput,
  ParameterLayerInput,
  ScratchPlateWellInput,
} from 'plates/dao/ScratchPlateDAO';
import {postJSONPromise} from 'util/Net';

const API_BASE = getApiBaseForObjectType(DomainGraphType.PLATE_DESIGN_TEMPLATE);

export interface CreatePlateDesignTemplateParams {
  scratchPlateId: string;
  templateCollectionId: string;
  name: string;
}

export interface CreatePlateDesignTemplateResponse {
  id: string;
}

export interface CreatePlateDesignTemplateFromScratchParams {
  templateCollectionId: string;
  name: string;
  height: number;
  width: number;
  wells?: Array<ScratchPlateWellInput>;
  concentrationLayers?: Array<ConcentrationLayerInput>;
  metadataLayers?: Array<MetadataColumnInput>;
  parameterLayers?: Array<ParameterLayerInput>;
  plateSchemaId?: string;
}

export interface CreatePlateDesignTemplateFromScratchResponse {
  id: string;
}

const PlateDesignTemplateDAO = {
  createPlateDesignTemplate(
    params: CreatePlateDesignTemplateParams
  ): Promise<CreatePlateDesignTemplateResponse> {
    return postJSONPromise({
      url: API_BASE,
      data: {
        scratchPlateId: params.scratchPlateId,
        templateCollectionId: params.templateCollectionId,
        name: params.name,
      },
    });
  },

  createPlateDesignTemplateFromScratch(
    params: CreatePlateDesignTemplateFromScratchParams
  ): Promise<CreatePlateDesignTemplateFromScratchResponse> {
    return postJSONPromise({
      url: `${API_BASE}:create-from-scratch`,
      data: {
        templateCollectionId: params.templateCollectionId,
        name: params.name,
        height: params.height,
        width: params.width,
        wells: params.wells,
        concentrationLayers: params.concentrationLayers,
        metadataLayers: params.metadataLayers,
        parameterLayers: params.parameterLayers,
        plateSchemaId: params.plateSchemaId,
      },
    });
  },
};

export default PlateDesignTemplateDAO;
